export var gridTypeForLayout = function gridTypeForLayout(layout) {
  return layout === 'wrap-left' || layout === 'wrap-right' ? 'wrapped' : 'full';
};